import { Film, Tv, Gamepad2, Music, BookOpen } from 'lucide-react';
import React from 'react';
import { CATEGORY_CONFIG, DEFAULT_CATEGORY } from '../constants/categories';

const ICON_MAP = {
  film: Film,
  series: Tv,
  game: Gamepad2,
  music: Music,
  book: BookOpen,
};

export const getCategoryIcon = (category, size = 12) => {
  const iconName = CATEGORY_CONFIG[category]?.iconName || DEFAULT_CATEGORY.iconName;
  const IconComponent = ICON_MAP[iconName];
  return IconComponent ? React.createElement(IconComponent, { size }) : null;
};

export const getCategoryColor = (category) => {
  return CATEGORY_CONFIG[category]?.color || DEFAULT_CATEGORY.color;
};

export const getCategoryNameRu = (category) => {
  return CATEGORY_CONFIG[category]?.nameRu || DEFAULT_CATEGORY.nameRu;
};

// Функция для получения названия категории через i18n
export const getCategoryName = (category, t) => {
  return t(`itemDetail.category.${category}`, category);
};